module.exports = __webpack_public_path__ + "img/acFlow3.5d988bd3.gif";